import { SET_PROJECTS_DATA } from './mutation-types'
import dataService from '@/services/data.service'

const africaData = dataService.getAfricaGeojson()

const africanCountries = africaData.features.map(country => {
  let polygon
  if (country.geometry.coordinates && country.geometry.coordinates[0]) {
    polygon = country.geometry.coordinates[0]
    if (country.geometry.coordinates[0][0].length > 2) {
      polygon = country.geometry.coordinates[0][0]
    }
  }

  if (!polygon && country.geometry.geometries) {
    polygon = [].concat(
      ...[].concat(...country.geometry.geometries[0].coordinates)
    )
  }
  const bounds = [[100, 100], [-100, -100]]
  polygon.forEach(point => {
    if (point[0] < bounds[0][0]) bounds[0][0] = point[0]
    if (point[0] > bounds[1][0]) bounds[1][0] = point[0]
    if (point[1] < bounds[0][1]) bounds[0][1] = point[1]
    if (point[1] > bounds[1][1]) bounds[1][1] = point[1]
  })
  return {
    iso3code: country.properties.iso3code,
    polygon,
    bounds,
  }
})

const state = {
  projects: dataService.getProjects(),
}

const mutations = {
  [SET_PROJECTS_DATA](state, payload) {
    state.projects = payload
  },
}

const actions = {
  getProjectsData({ commit }) {
    const data = dataService.getProjects()
    commit(SET_PROJECTS_DATA, data)
  },
}

const getters = {
  allProjects: state => state.projects,
  projects: (state, getters, rootState, rootGetters) => {
    return state.projects.filter(project => {
      const sdg = rootGetters['companies/selectedSdg']
      let sdgMatch = false
      if (!sdg.length) {
        sdgMatch = true
      } else {
        sdgMatch = sdg.some(item => project.data.sdg.includes(item))
      }
      const displayNameQuery = rootGetters['companies/selectedDisplayName']
      const displayName = project.displayName
      let displayNameMatch = false
      if (!displayName) {
        displayNameMatch = true
      } else {
        const splittedQueries = displayNameQuery.toLowerCase().split(' ')
        displayNameMatch = splittedQueries.every(query => {
          return displayName.toLowerCase().includes(query)
        })
      }
      return sdgMatch && displayNameMatch
    })
  },
  inBoundsProjects: (state, getters, rootState, rootGetters) => {
    const viewport = rootGetters['map/bounds']
    const viewportBounds = [
      [viewport._northEast.lng, viewport._southWest.lat],
      [viewport._northEast.lng, viewport._northEast.lat],
      [viewport._southWest.lng, viewport._southWest.lat],
      [viewport._southWest.lng, viewport._northEast.lat],
    ]

    const visibleCountries = []
    africanCountries.forEach(country => {
      const intersectsWithViewport = country.polygon.some(point => {
        const lat =
          (point[0] - viewportBounds[1][0]) *
            (point[0] - viewportBounds[2][0]) <
          0
        const lng =
          (point[1] - viewportBounds[1][1]) *
            (point[1] - viewportBounds[2][1]) <
          0
        return lng && lat
      })
      let completelyWithin
      if (!intersectsWithViewport) {
        if (
          (country.bounds[0][0] > viewportBounds[0][0] &&
            country.bounds[1][0] < viewportBounds[1][0] &&
            country.bounds[0][1] > viewportBounds[0][1] &&
            country.bounds[1][1] < viewportBounds[1][1]) ||
          (viewportBounds[0][0] > country.bounds[0][0] &&
            viewportBounds[1][0] < country.bounds[1][0] &&
            viewportBounds[0][1] > country.bounds[0][1] &&
            viewportBounds[1][1] < country.bounds[1][1])
        ) {
          completelyWithin = true
        }
      }
      if (intersectsWithViewport || completelyWithin) {
        visibleCountries.push(country.iso3code)
      }
    })

    const projectsInVisibleCountries = getters.projects.filter(project => {
      return visibleCountries.includes(project.country_iso3)
    })
    return projectsInVisibleCountries
  },

  allProjectsCount: state => state.projects.length,
  filteredProjectsCount: (state, getters) => getters.projects.length,
  inBoundsProjectsCount: (state, getters) => getters.inBoundsProjects.length,
  inBoundsProjectsBudget: (state, getters) => {
    return getters.inBoundsProjects.reduce((total, project) => {
      if (project.data.budget) {
        return (total += project.data.budget)
      }
      return total
    }, 0)
  },
  allProjectsBudget: state => {
    return state.projects.reduce((total, project) => {
      if (project.data.budget) {
        return (total += project.data.budget)
      }
      return total
    }, 0)
  },
  allProjectsSdg: state => {
    return state.projects.reduce((counts, project) => {
      if (project.data.sdg && project.data.sdg.length) {
        project.data.sdg.forEach(item => {
          if (!counts[item]) {
            counts[item] = 1
          } else {
            counts[item] += 1
          }
        })
      }
      return counts
    }, {})
  },
  inBoundsProjectsSdg: (state, getters) => {
    return getters.inBoundsProjects.reduce((counts, project) => {
      if (project.data.sdg && project.data.sdg.length) {
        project.data.sdg.forEach(item => {
          if (!counts[item]) {
            counts[item] = 1
          } else {
            counts[item] += 1
          }
        })
      }
      return counts
    }, {})
  },
  visibleProjectIds: (state, getters) => {
    return getters.inBoundsProjects.map(
      project => project.data.project_id
    )
  },
  budgetsPerSdg: (state, getters) => {
    const visibleProjectIds = getters.visibleProjectIds
    return state.projects.reduce((counts, project) => {
      if (project.data.sdg && project.data.sdg.length) {
        project.data.sdg.forEach(item => {
          const budget = +project.total_budget
          if (!counts[item]) {
            counts[item] = { total: budget, visible: 0 }
          } else {
            counts[item].total += budget
          }

          if (visibleProjectIds.includes(project.data.project_id)) {
            counts[item].visible += +project.total_budget
          }
        })
      }
      return counts
    }, {})
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
